import {Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, from, mergeMap, Observable, of } from 'rxjs';
import { CommonResponse } from '../models';
import { catchError, map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UtilityTranslateService {
	constructor(private _translateService: TranslateService) {
	}

	// private translateKey(key: string): Observable<string> {
	// 	return this._translateService.instant(key);
	// }
	//
	// private translateArray(arr: any[]): Observable<any[]> {
	// 	return forkJoin(arr.map(item => {
	// 		if (Array.isArray(item)) {
	// 			return this.translateArray(item);
	//
	// 		} else if (typeof item === 'object') {
	//
	// 			return this.translateObjectValues(item);
	//
	// 		} else if (typeof item === 'string') {
	//
	// 			return this.translateKey(item);
	//
	// 		} else {
	//
	// 			return of(item);
	//
	// 		}
	// 	}));
	// }
	//
	// private translateObjectValues(obj: { [key: string]: any }) {
	// 	if (obj) {
	// 		const values$ = Object.keys(obj)
	// 		values$.map(item => {
	// 			return (typeof obj[item] === 'object') ? this.translateObjectValues(obj[item]) : this.translateKey(obj[item]);
	// 		})
	//
	//
	// 		return forkJoin(values$).pipe(
	// 			map(translatedValues => {
	// 				const result: { [key: string]: any } = {};
	// 				Object.keys(obj).forEach((key, index) => {
	// 					result[key] = translatedValues[index];
	// 				});
	// 				return result;
	// 			})
	// 		);
	// 	}
	//
	// 	// const values$ = Object.values(obj).map((value, index) => {
	// 	// 	return (typeof value === 'object') ? this.translateObjectValues(value) : this.translateKey(value);
	// 	// });
	// }
	//
	// getTranslations(data: any[]): Observable<CommonResponse<any[]>> {
	// 	return from(this.getTranslationsAsync(data));
	// }
	//
	// private getTranslationsAsync(data: any[]): Observable<CommonResponse<any[]>> {
	// 	return this.translateArray(data).pipe(
	// 		map(translatedData => ({ code: 200, message: '', data: translatedData })),
	// 		catchError(error => of({ message: '', errors: error.message, data: [], code: 0 }))
	// 	);
	// }

	getTranslations(key, array) {
		const deepTranslate = (obj, keyPath) => {
			if (obj && typeof obj === 'object') {
				for (const prop in obj) {
					if (obj.hasOwnProperty(prop)) {
						const currentKeyPath = keyPath ? `${keyPath}.${prop}` : prop;

						if (typeof obj[prop] === 'object') {
							obj[prop] = deepTranslate(obj[prop], currentKeyPath);
						} else if (currentKeyPath === key) {
							obj[prop] = this._translateService.instant(obj[prop]);
						}
					}
				}
			}
			return obj;
		};

		const newArray = array.map((item) => deepTranslate({ ...item }, ''));

		return newArray;
	}
}
